import { BidFiles } from './BidFiles';

export class tbl_BidFileName {
  id?: number;
  empId?: number;
  fieldId?: string;
  bidFiles?: BidFiles[] = [];
}
